import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Why does my CPA firm need this executive dashboard?",
      answer: "Many CPA firms face challenges with reporting from their practice management software. While platforms like Thomson Reuters Practice CS and Wolters Kluwer CCH are widely used, they often lack robust reporting and data analytics capabilities. This can lead to time-consuming processes and missed opportunities for optimizing operations.\n\nPulling reports such as WIP, billing by project, or timesheets is often cumbersome and labor-intensive. Most firms only discover these issues too late—either at month-end billing or when someone has the time to pull and review the reports.\n\nOur executive dashboard addresses these challenges by providing real-time, automated reporting and data analysis, allowing you to make informed decisions quickly and efficiently, ultimately saving time and enhancing productivity."
    },
    {
      question: "How do you integrate with Practice CS?",
      answer: "Integration takes 1–2 weeks. We work closely with your admin team and deploy within your secure environment."
    },
    {
      question: "Is data secure?",
      answer: "All data stays within your infrastructure. You define access rules. We take privacy seriously."
    },
    {
      question: "How do we access reports?",
      answer: "You can access dashboards from desktop, web, or mobile."
    },
    {
      question: "How frequently is data updated?",
      answer: "Typically daily, but update frequency is customizable."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Questions?
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about Practice Dashboard
          </p>
        </div>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <button
                className="w-full px-8 py-6 text-left focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-inset hover:bg-gray-50 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-start">
                  <h3 className="text-lg font-bold text-gray-900 pr-4 leading-relaxed">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    {openIndex === index ? (
                      <ChevronUp className="w-5 h-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-500" />
                    )}
                  </div>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6 border-t border-gray-50">
                  <div className="pt-6 text-gray-700 leading-relaxed whitespace-pre-line">
                    {faq.answer}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <a 
            href="/contact" 
            className="inline-flex items-center px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-colors"
          >
            Contact our team
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;